import React from "react";
import CoachingPage from "./CoachingPage";

const WelcomeCallWithRayPage: React.FC = () => (
  <CoachingPage hideNavigation trackWelcomeCallEvents />
);

export default WelcomeCallWithRayPage;
